
export const iconButton = {
  size: '48px'
};
export const icon = {
  fontSize: '24px'
};

export const zIndex = {
  toolbar: 1000,
  drawer: 1100,
  overlay: 1200
};

export const RippleVariables = {
  transition: {
    opacity: 'cubic-bezier(0.4,0.0,1,1)',
    transform: 'cubic-bezier(0, 1, 0.6, 1)'
  },
  duration: 950
};

export const animations = {
  curves: {
    standard: 'cubic-bezier(0.4,0.0,0.2,1)',
    deceleration: 'cubic-bezier(0.0,0.0,0.2,1)',
    acceleration: 'cubic-bezier(0.4,0.0,1,1)',
    sharp: 'cubic-bezier(0.4,0.0,0.6,1)'
  },
  durations: {
    complex: 375,
    entering: 225,
    exiting: 195
  }
};
